import SuperUserAppBar from './SuperUserAppBar'

/**
 * Custom `TemplateSelector` component declaration.
 * Load SuperUserAppBar
 * @return TemplateSelector
*/
const TemplateSelector = (): JSX.Element => {
  return (
    <>
      <SuperUserAppBar />
    </>
  )
}

export default TemplateSelector